import { render } from "./UserRegisterComplete.vue?vue&type=template&id=56e0311e&scoped=true"
import script from "./UserRegisterComplete.vue?vue&type=script&lang=js"
export * from "./UserRegisterComplete.vue?vue&type=script&lang=js"

import "./UserRegisterComplete.vue?vue&type=style&index=0&id=56e0311e&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e0311e"]])

export default __exports__